module.exports = __webpack_public_path__ + "6a2e8a3d0218c26ab2096a8301093038.svg";